import { useState, useEffect } from 'react';
import {
  CircularProgress,
  Divider,
  Typography,
} from '@mui/material';
import SortableTable from './SortableTable';
import CsvTableExport from '../export/CsvTableExport';
import PdfTableExport from '../export/PdfTableExport';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './ReportTable.scss';

const ReportLoader = () => (
  <div className='report-loader' data-test='report-loader'>
    <CircularProgress />
    <p>Loading ...</p>
  </div>
);

const defaultProps = {
  className: '',
  tableData: [],
  config: [],
  fileName: [],
  title: '',
  loading: false,
  header: null,
  customPrintPdf: null,
  onTableStateChange: () => {},
  initTableState: undefined,
};
const ReportTable = (props) => {
  const {
    className,
    fileName,
    title,
    config,
    tableData,
    loading,
    header,
    customPrintPdf,
    onTableStateChange,
    initTableState,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const [sortedTableData, setSortedTableData] = useState(tableData);

  useEffect(() => {
    setSortedTableData(tableData);
  }, [tableData]);

  return (
    loading ? <ReportLoader /> : (
      <div {...rest} className={`${className} report-table`}>
        {header ? (
          <div className='header'>
            <Typography variant='h6'>
              {header}
            </Typography>
            <Divider />
          </div>
        ) : null}
        <div className='export-toolbar'>
          <CsvTableExport
            config={config}
            tableData={sortedTableData}
            filename={`${fileName}.csv`}
          />

          <PdfTableExport
            filename={`${fileName}.pdf`}
            title={title}
            config={config}
            tableData={sortedTableData}
            customPrint={customPrintPdf}
          />
        </div>
        <SortableTable
          config={config}
          tableData={tableData}
          onTableSort={(sortedData) => { setSortedTableData(sortedData); }}
          onTableStateChange={onTableStateChange}
          initTableState={initTableState}
        />
      </div>
    ));
};

export default ReportTable;
